// Zustand
import { create } from "zustand"

// ---------------------------------------------|| PROFILE - STORE ||----------------------------------------------------

const useProfileStore = create(set => ({
  profileData: {},
  setProfileData: data => set({ profileData: data })
}))

export default useProfileStore
